import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule, FormArray } from '@angular/forms';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { MatInputModule } from '@angular/material/input';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { SelectProjectDesignComponent } from '@/app/components/projects/shared/tendering/ITT/answer-selected-questions/select-project-design/select-project-design.component';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { FileManagerComponent } from "@/app/components/shared/file-manager/file-manager.component";

@Component({
  selector: 'app-create-addendum',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    RichTextEditorComponent,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FileManagerComponent
  ],
  templateUrl: './create-addendum.component.html',
  styleUrl: './create-addendum.component.css',
})
export class CreateAddendumComponent {
  resetRichTextEditor = false;
  addendumDetails = '';
  selectedFiles: any[] = [];
  selectedProjectDesignFiles: any = [];

  myForm = new FormGroup({
    titleControl: new FormControl(''),
    newAddendumFiles: new FormArray([]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly dialogData: any,
    private createAddendumDialogRef: MatDialogRef<CreateAddendumComponent>,
    private tenderingService: TenderingService,
    private dialog: MatDialog,
    private getFileIconService: GetFileIconUtilityService,
  ) { }

  addProjectSiteCondition(content: string) {
    this.addendumDetails = content;
  }

  close(success: boolean = false) {
    this.createAddendumDialogRef.close({ success: success });
  }

  prepareDataToSubmit() {
    if (!this.myForm.get('titleControl')) {
      console.log('invalid');
      return;
    }

    const dataToSubmit = new FormData();

    // Append non-file data
    dataToSubmit.append('title', this.myForm.get('titleControl')?.value);
    dataToSubmit.append('details', this.addendumDetails);
    dataToSubmit.append('files', JSON.stringify(this.selectedProjectDesignFiles));

    // Append new addendum files
    if (this.myForm.value.newAddendumFiles && Array.isArray(this.myForm.value.newAddendumFiles)) {
      this.myForm.value.newAddendumFiles.forEach((uploadedFile: File) => {
        if (uploadedFile) {
          dataToSubmit.append(`rfp_addendum_files[]`, uploadedFile);
        }
      });
    }

    return dataToSubmit;
  }

  // Get the file icon from the service
  getFileIcon(filePath): string {
    return this.getFileIconService.getFileIconByFilePath(filePath);
  }

  removeSelection(index: number, file: any): void {
    const tabName = file.type;

    if (this.selectedProjectDesignFiles[tabName]) {
      this.selectedProjectDesignFiles[tabName] = this.selectedProjectDesignFiles[tabName].filter(doc => doc.id !== file.id);
    }

    this.selectedFiles.splice(index, 1);
  }

  openRFPDesignUploadDialog(): void {
    const designDialogueRef = this.dialog.open(SelectProjectDesignComponent, {
      width: '80vw',
      // height: '70vh',
      panelClass: 'custom-dialog-container',
      maxWidth: '80vw',
      autoFocus: false, // Prevent automatic focus stealing
      disableClose: true, // Prevent closing on outside click
      data: {
        projectId: this.dialogData.projectId,
        selectedProjectDesignFiles: this.selectedProjectDesignFiles
      },
    });

    designDialogueRef.afterClosed().subscribe((result: any) => {
      if (result?.success) {
        this.selectedProjectDesignFiles = result?.selectedFiles;
        this.mapSelectedFiles(result?.selectedFiles);
      } else {
        console.warn('No valid approval found in the response:', result);
      }
    });
  }

  mapSelectedFiles(result: any): void {
    const categories = [
      'drawing',
      'specifications',
      'calculations',
      'surverys_reports_studies',
      'design_review_reports',
      'permits_and_applications',
      'design_signoff',
      'rfi',
      'addendums',
    ];

    this.selectedFiles = categories.flatMap(
      (category) =>
        result[category]?.map((file: any) => ({
          id: file.id,
          name: file.title,
          filePath: file.file_path,
          type: file.type,
        })) || []
    );
  }

  /**
   * Handling File Operations - START
   */
  // Uploading/Deleting new files for site preparation
  handleNewFiles(filesData: {
    files: File[],
    controlName: string,
    isEmpty: boolean,
  }) {
    switch (filesData.controlName) {
      case 'newAddendumFiles': {
        const fileArray = this.myForm.get('newAddendumFiles') as FormArray;
        fileArray.clear();
        // If no files are present, we break
        if (filesData.isEmpty) { break; }
        filesData.files.forEach(file => fileArray.push(new FormControl(file)));
        break;
      }

      default:
        break;
    }
  }
  /**
   * Handling File Operations - END
   */

  submitRFPAddendum() {
    const data = this.prepareDataToSubmit();

    return this.tenderingService
      .storeRfpAddendem(
        data,
        this.dialogData.projectId,
        this.dialogData.rfpId
      )
      .subscribe({
        next: (response: any) => {
          if (response.meta.success) {
            this.close(true);
          }
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });
  }
}

